var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info (1) 1",
    clipPath: "url(#clip0_984_17685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.439209 20.4392C0.439209 9.63598 9.19689 0.878296 20.0001 0.878296C30.8033 0.878296 39.561 9.63598 39.561 20.4392C39.561 30.4207 32.0845 38.6555 22.4262 39.8503C21.6312 39.752 20.8216 39.7006 20.0001 39.7006C19.1785 39.7006 18.369 39.752 17.574 39.8503C7.9157 38.6555 0.439209 30.4207 0.439209 20.4392Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.9364 19.9681C35.9364 28.787 28.7872 35.9361 19.9683 35.9361C11.1494 35.9361 4.00024 28.787 4.00024 19.9681C4.00024 11.1491 11.1494 4 19.9683 4C28.7872 4 35.9364 11.1491 35.9364 19.9681Z",
    fill: "#FFC107",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.0201 19.968C34.0201 27.7287 27.7288 34.0199 19.9682 34.0199C12.2075 34.0199 5.91626 27.7287 5.91626 19.968C5.91626 12.2074 12.2075 5.91614 19.9682 5.91614C27.7288 5.91614 34.0201 12.2074 34.0201 19.968Z",
    fill: "#FFC107",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.1793 19.9681C32.1793 26.7119 26.7123 32.1789 19.9684 32.1789C13.2246 32.1789 7.75757 26.7119 7.75757 19.9681C7.75757 13.2242 13.2246 7.7572 19.9684 7.7572C26.7123 7.7572 32.1793 13.2242 32.1793 19.9681Z",
    fill: "#FF9F0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.8424 32.0358C21.2315 32.1299 20.6057 32.1789 19.9684 32.1789C13.2246 32.1789 7.75757 26.7119 7.75757 19.9681C7.75757 13.2242 13.2246 7.7572 19.9684 7.7572C20.6056 7.7572 21.2314 7.80622 21.8424 7.90028C15.9881 8.80191 11.5054 13.8614 11.5054 19.9681C11.5054 26.0747 15.9881 31.1342 21.8424 32.0358Z",
    fill: "#E9910A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.0404 26.3553C24.0404 27.2373 23.3256 27.9522 22.4436 27.9522H17.4935C16.6116 27.9522 15.8967 27.2373 15.8967 26.3553C15.8967 25.4734 16.6116 24.7585 17.4935 24.7585H18.3718V19.9681H17.4935C16.6116 19.9681 15.8967 19.2532 15.8967 18.3713C15.8967 17.4894 16.6116 16.7745 17.4935 16.7745H22.4436C23.3256 16.7745 24.0404 17.4894 24.0404 18.3713C24.0404 19.2532 23.3256 19.9681 22.4436 19.9681H21.5654V24.7585H22.4436C23.3256 24.7585 24.0404 25.4734 24.0404 26.3553ZM19.9686 15.1777C21.1984 15.1777 22.1953 14.1808 22.1953 12.951C22.1953 11.7213 21.1984 10.7244 19.9686 10.7244C18.7388 10.7244 17.7419 11.7213 17.7419 12.951C17.7419 14.1808 18.7388 15.1777 19.9686 15.1777Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.7415 12.951C17.7415 11.7213 18.7384 10.7244 19.9682 10.7244C20.3029 10.7244 20.6202 10.7987 20.9051 10.9311C20.1436 11.2849 19.6154 12.056 19.6154 12.951C19.6154 13.846 20.1436 14.6171 20.9051 14.971C20.6202 15.1034 20.3029 15.1777 19.9682 15.1777C18.7384 15.1777 17.7415 14.1808 17.7415 12.951ZM17.0806 26.9475C17.0806 26.3926 17.5304 25.9429 18.0852 25.9429H19.4259C19.7081 25.8075 19.9033 25.52 19.9033 25.1861V19.6106C19.9033 19.1961 19.6027 18.8526 19.2079 18.7839H18.0852C17.5304 18.7839 17.0806 18.3341 17.0806 17.7793C17.0806 17.2245 17.5304 16.7747 18.0852 16.7747H17.5314C16.6655 16.7747 15.9281 17.448 15.8973 18.3133C15.865 19.2215 16.5919 19.9681 17.4931 19.9681H18.3714V24.7585H17.5314C16.6655 24.7585 15.9281 25.4318 15.8973 26.2971C15.865 27.2056 16.5919 27.9522 17.4931 27.9522H18.0853C17.5304 27.9522 17.0806 27.5023 17.0806 26.9475Z",
    fill: "#FADEB9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_984_17685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSvg);
export default __webpack_public_path__ + "static/media/InfoSvg.4685881f3387b966603942dd04cd4dc0.svg";
export { ForwardRef as ReactComponent };